/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
//SmartMap.WebService.Models.Models.SinglePathMission

import { AreaPolygon } from './AreaPolygon';
import { SimplePoint } from './SimplePoint';
import { Guid } from 'guid-typescript';
import { JsonHelper } from '../services/JsonHelper';
import { deserializeArray, deserialize, serialize, Type } from 'class-transformer';
import { ActionIndex } from './ActionIndex';

export interface ISinglePathMission {
  MissionID: string;
  MissionName: string;
  CustomerID: string;
  ReferencePathID: string;
  Path: SimplePoint[];
  WorkAreas: SimplePoint[][];
  CropAreas: SimplePoint[][];
  ReferenceFieldID: string;
  FieldBoundary: AreaPolygon;
  TargetSpeedKph: number;
  ApplicationParameters: string;
  LastModifiedUTC: Date;
  ImplementCode: string;
  PathActions: ActionIndex[];
}

export class SinglePathMission implements ISinglePathMission {
  MissionID: string;

  MissionName: string;

  CustomerID: string;

  ReferencePathID: string;

  Path: SimplePoint[];

  WorkAreas: SimplePoint[][];

  CropAreas: SimplePoint[][];

  ReferenceFieldID: string;

  FieldBoundary: AreaPolygon;

  TargetSpeedKph: number;

  ApplicationParameters: string;

  PathActions: ActionIndex[];

  @Type(() => Date)
  LastModifiedUTC: Date;

  ImplementCode: string;

  constructor() {
    this.MissionID = Guid.EMPTY.toString();
    this.MissionName = '';
    this.CustomerID = Guid.EMPTY.toString();
    this.ReferencePathID = Guid.EMPTY.toString();
    this.FieldBoundary = { DrawPoints: [] };
    this.Path = [];
    this.WorkAreas = [[]];
    this.CropAreas = [[]];
    this.ReferenceFieldID = Guid.EMPTY.toString();
    this.TargetSpeedKph = 0;
    this.ApplicationParameters = '';
    this.LastModifiedUTC = new Date();
    this.ImplementCode = Guid.EMPTY.toString();
    this.PathActions = [];
  }

  static toModel(json: string): SinglePathMission {
    const singlePathMission = deserialize(SinglePathMission, json);
    return singlePathMission;
  }

  static toModelCollection(json: string): SinglePathMission[] {
    const singlePathMissions = deserializeArray(SinglePathMission, json);
    return singlePathMissions;
  }

  public fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }

  public getApplicationParameters(): Map<string, string> {
    return JsonHelper.IsJson(this.ApplicationParameters) ? new Map(Object.entries(JSON.parse(this.ApplicationParameters))) : new Map<string, string>();
  }

  // Convert a dictionary to a string and assign it to ApplicationParameters of the mission
  public setApplicationParameters(params: Map<string, string>): SinglePathMission {
    this.ApplicationParameters = JSON.stringify(Array.from(params.entries()).reduce((main, [key, value]) => ({ ...main, [key]: value }), {}));
    return this;
  }
}